import { FlowActions } from '@eneco/flows/types';

import { FlowConsumerContextEnergy } from '../../context';
import { setUsageKnown, setUsageEstimatedValues, resetUsageValues, resetSolarPanelsOutput } from '../actions';

export const flowActions: FlowActions<FlowConsumerContextEnergy> = {
  setUsageKnown,
  setUsageEstimatedValues,
  resetUsageValues,
  resetSolarPanelsOutput,
};
